const DOCUMENT_STATUSES = {
  mapped: 'mapped',
  uploaded: 'uploaded',
  sent: 'sent',
};

export { DOCUMENT_STATUSES };
